import * as React from 'react';
import classnames from 'classnames';
import { AnimatePresence } from 'framer-motion';
import { CheckboxWithLabel } from '@grandvisionhq/forms';
import { TitleWithIcon } from '../../../../components/TitleWithIcon/TitleWithIcon.js';
import { HighlightedForm } from '../../HighlightedForm.js';

const BillingAndDeliveryForm = ({ className , billingAddressForm , isDelivery , isDeliveryExpress , deliveryAddress , onToggleDeliveryAddress , deliveryAddressForm , labels ,  })=>{
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('billing-and-delivery-form', className),
        "data-t": "billing-and-delivery-form"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, billingAddressForm), (isDelivery || isDeliveryExpress) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        id: "usingDeliveryAddress",
        value: "usingDeliveryAddress",
        checked: !Boolean(deliveryAddress),
        onChange: onToggleDeliveryAddress,
        className: "billing-and-delivery-form__checkbox",
        label: labels.differentDeliveryAddress
    }), /*#__PURE__*/ React.createElement(AnimatePresence, null, deliveryAddress && /*#__PURE__*/ React.createElement(HighlightedForm, {
        key: "delivery-highlight",
        className: "checkout-step__highlight"
    }, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "location-pin",
        label: labels.deliveryAddress
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, deliveryAddressForm)))));
};

export { BillingAndDeliveryForm };
//# sourceMappingURL=BillingAndDeliveryForm.js.map
